import React, { useEffect, useState } from "react";

interface AdProps {
  onAdStatusChange: (isAdOpen: boolean) => void;
}

//  google ad script

const Ad: React.FC<AdProps> = ({ onAdStatusChange }) => {
  const [ isAdOpen, setIsAdOpen ] = useState( false );

  /* --- Attach Google ad script and report ad status to navbar --- */
  useEffect(() => {
    const script = document.createElement('script');
    script.text = "googletag.cmd.push(function() { googletag.display('div-gpt-ad-1481300860418-0'); });";
    script.async = true;

    // Check div exists in DOM before appending
    const adDivWithId = document.getElementById("div-gpt-ad-1481300860418-0");
    if (adDivWithId) {
      document.body.appendChild(script);
    }

    let count = 0;
    const intervalTimer = setInterval(() => {
      count += 0.25;

      const adContainer = document.getElementById("gpt--leaderboard-ad--masthead");
      const adIFrame = document.getElementById("google_ads_iframe_/181614894/728x90leaderboard_0__container__");

      // ad doesn't exist
      if ((adDivWithId && !adDivWithId.hasChildNodes()) || (adIFrame && adContainer && adIFrame.clientHeight === 0)) {
        if (isAdOpen) {
          setIsAdOpen( false );
        }
        if (adContainer) {
          adContainer.style.display = "none";
        }
      }
      // ad exists
      else {
        if (!isAdOpen) {
          setIsAdOpen( true );
        }
      }

      // after 8 seconds, stop checking for ad
      if (count >= 32) {
        clearInterval(intervalTimer);
      }
    }, 250);

    return () => {
      document.body.removeChild(script);
      clearInterval(intervalTimer);
    }
  }, []);


  /* --- Report banner status to nav parent  --- */
  useEffect(() => {
    onAdStatusChange( isAdOpen );
  }, [ isAdOpen, onAdStatusChange ])

  return (
    <div id="gpt--leaderboard-ad--masthead" >
      {/* /181614894/728x90leaderboard */}
      <div id="div-gpt-ad-1481300860418-0"></div>
    </div>
  );
}

export default Ad;
